var off = require('./dom-event').off
module.exports = function () {
  var self = this
  var element = self.element

  off(element, 'keypress', self.eventHandler)
  off(element, 'keydown', self.eventHandler)
  off(element, 'keyup', self.eventHandler)
}



//////////////////
// WEBPACK FOOTER
// D:/agent/4/_work/121/s/common/~/combokeys/Combokeys/prototype/detach.js
// module id = 150
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///D:/agent/4/_work/121/s/common/~/combokeys/Combokeys/prototype/detach.js